module.exports = __webpack_public_path__ + "img/h5_game_detail_penta5_regular.2ad9a1c7.jpg";